/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable promise/catch-or-return */

import * as ActionTypes from '../ActionTypes';
import ArticlesApi from '../../api/Articles';
export function fetchVersions(articleId, offset = 0) {
  return dispatch => {
    dispatch({
      type: ActionTypes.FETCH_ARTICLE_VERSIONS_PENDING
    });
    return ArticlesApi.fetchVersions(articleId, offset).then(res => {
      dispatch({
        type: ActionTypes.FETCH_ARTICLE_VERSIONS_SUCCESS,
        payload: res
      });
    }, error => {
      dispatch({
        type: ActionTypes.FETCH_ARTICLE_VERSIONS_ERROR,
        error
      });
    });
  };
}
export function restoreVersion(articleId, versionId) {
  return () => {
    ArticlesApi.restoreVersion(articleId, versionId).then(() => {
      window.location.reload();
    });
  };
}